import { render } from "./FormValidationPage.vue?vue&type=template&id=2d6a1515&ts=true"
import script from "./FormValidationPage.vue?vue&type=script&lang=ts"
export * from "./FormValidationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__